import { generatePath } from "react-router";
import { DriverProfileDto, FleetDto, Maybe, TagCategoryDto, TagDto } from "generated/graphql";
import { EntityPageMode, getCreatePathTemplate, getEntityPathTemplate } from "navigation/utils";

export function generateCreatePath(basePath: string) {
  return generatePath(getCreatePathTemplate(basePath), { mode: EntityPageMode.create });
}

export function generateViewPath<T extends { id?: Maybe<number> }>(basePath: string, params: T | undefined | null) {
  if (!params || !params?.id) {
    return "#";
  }
  return generatePath(getEntityPathTemplate(basePath), {
    ...params,
    mode: EntityPageMode.view,
  });
}

export function generateEditPath<T extends { id?: Maybe<number> }>(basePath: string, params: T | undefined | null) {
  if (!params || !params?.id) {
    return "#";
  }
  return generatePath(getEntityPathTemplate(basePath), {
    ...params,
    mode: EntityPageMode.edit,
  });
}

export const links = {
  support: "https://tecorien.screenconnect.com/",
  appRoot: "/",
  accessDenied: "/403",
  profile: "/profile",
  driverProfile: "/drivers",
  tag: "/tags",
  tagCategory: "/tag-categories",
  fleet: "/fleets",
  exportFiles: "/export-files",
  fileRequests: "/file-requests",
  appendToLOP: "/append-to-lop",
  public: "/public",
  publicAttachment: "/public/attachment",
  publicCLCodeOfConduct: "/public/cl-code-of-conduct",
  publicPACEOrientationAndDriverTraining: "/public/pace-orientation-and-driver-training",
};

export const getLink = {
  getDriverProfilesLink: links.driverProfile,
  getCreateDriverProfileLink: generateCreatePath(links.driverProfile),
  getDriverProfileLink: (driverProfile: Partial<DriverProfileDto>) => generateViewPath(links.driverProfile, driverProfile),

  getTagsLink: links.tag,
  getCreateTagLink: generateCreatePath(links.tag),
  getTagLink: (tag: Partial<TagDto>) => generateViewPath(links.tag, tag),

  getTagCategoriesLink: links.tagCategory,
  getCreateTagCategoryLink: generateCreatePath(links.tagCategory),
  getTagCategoryLink: (tagCategory: Partial<TagCategoryDto>) => generateViewPath(links.tagCategory, tagCategory),

  getFleetsLink: links.fleet,
  getCreateFleetLink: generateCreatePath(links.fleet),
  getFleetLink: (fleet: Partial<FleetDto>) => generateViewPath(links.fleet, fleet),
};


Object.freeze(links);
Object.freeze(getLink);
